import * as types from '../Types/TenantTypes';

const initialState = {
  config: null,
  clientAssets: null,
  loading: false,
  error: null,
  features: {},
  providers: []
};

export default function TenantReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TENANT_CONFIG:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_TENANT_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.result,
        features: action.result.features || {},
        providers: action.result.auth_providers || [],
        error: null
      };

    case types.FETCH_TENANT_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case types.SET_CLIENT_ASSETS:
      return {
        ...state,
        clientAssets: action.payload
      };

    default:
      return state;
  }
}
